import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';

import { Oval } from  'react-loader-spinner'
import _ from 'lodash'


const pageSize =5;
const pageSizeB =5;

const TecLeadersMain = () => {


useEffect(()=>{

 
        
   
  setTimeout(() => {
            
  
  getroleAction() 

    
   }, 2000);
   
   
  
})


  
    
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken')); 

  const [sectionLeaders, setSectionLeaders] = useState([])
  const [EditSectionLeaders, setEditSectionLeaders] =useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);
  const [paginatedPostsB, setpaginatedPostsB] = useState();
  const [currentPageB, setcurrentPageB] = useState(1);
 ///getTecLeaders


 function getTecLeaders()
 {

 

 fetch(`${BASE_URL}/Tec/GettecLeaders`, {

   method: 'GET',

   headers: {

     "Content-type": "application/json",

     "Accept": "application/json",

     

     "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

   },

   //body:JSON.stringify(data)

 }).then(response => response.json())

   .then(data => {
     console.log("DatasectionA", data);
     setSectionLeaders(data)
     setpaginatedPosts(_(data).slice(0).take(pageSize).value());
       }
   );



     }

     const pageCount = sectionLeaders? Math.ceil(sectionLeaders.length/pageSize) :0;
     // if (pageCount === 1)
     // return null;
     
     const pages = _.range(1, pageCount+1)
     
     const pagination =(pageNo)=>{
     setcurrentPage(pageNo);
     const startIndex = (pageNo - 1) * pageSize;
     const paginatedPost = _(sectionLeaders).slice(startIndex).take(pageSize).value();
     setpaginatedPosts(paginatedPost)
     }
     const onNext = () => {


       pagination(currentPage + 1);
     };
   
     const onPrevious = () => {
       pagination(currentPage - 1);
     };


       ///submitsectionLeaders

   const [fileLeaders, setFileLeaders] = useState();
   const [fileLeadersImg, setFileLeadersImg] = useState();
   // console.log(file)
   
   const handleFileChangeLeaders = (e) => {
    
       setFileLeaders(e.target.files[0]);
       setFileLeadersImg(URL.createObjectURL(e.target.files[0]));
   };
 
   function submitsectionLeaders(){

    var UserId= localStorage.getItem('UserId')

     var textLeaders = document.getElementById("text").value;


     if(!textLeaders){

       document.getElementById("AddErrA").innerHTML="Leader Name Required"

     }
     else if(textLeaders){

       document.getElementById("AddErrA").innerHTML=" "

     }
     
     if(!fileLeaders){

       document.getElementById("AddErrB").innerHTML="image Required"

     }
     else if(fileLeaders){

       document.getElementById("AddErrB").innerHTML=" "

     }

     if(textLeaders &&fileLeaders){



    const body =
     {
       
       Text:textLeaders, 
       Image:fileLeaders,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecLeaders`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
            // toast.success("Section Added")
            setSuccessToast(true)
          
             setTimeout(() => {
              setSuccessToast(false)
              getTecLeaders()

              closeLeadersAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
    alert("failed to Add") 

     })
       
   }

   }


 ////Get Particular Data PostMethodLeaders

 function SelectParticularMain(Id){


  

const body =
 {
   
  id:Id
 }
 console.log('body',body);


 axios({
        method:"POST",
        url :`${BASE_URL}/Tec/EdittecLeaders`,
        data:body, 
        headers: {
             "Content-type": "application/json",
             'Authorization':bearer 
         }     
     }) 
     

     .then((response) =>{
       console.log(JSON.stringify(response.data));
  
   
       setEditSectionLeaders(response.data)

      
  
    })
    .catch(error => {
      console.log(error);
      
    })

 }
function editSectionLeaders(Id){

  SelectParticularMain(Id)

  document.getElementById("LeadersEditPop").style.display = "block";

}

 function updateSectionLeaders(Id){


  var UserId= localStorage.getItem('UserId')
  var TextLeaders = document.getElementById("textA").value;
  var ImagefileLeaders = document.getElementById("tecimage").src;

  if(!TextLeaders){

    document.getElementById("ErrA").innerHTML="Leader Name Required"

  }
  else if(TextLeaders){

    document.getElementById("ErrA").innerHTML=" "

  }
  
 
 
 
  if(TextLeaders){


  



const body =
{
  Id:Id,
  Text:TextLeaders, 
  Image:fileLeaders,
  OldImage:ImagefileLeaders,
  EditedBy:UserId

   

}
console.log('body',body);


axios({
       method:"POST",
       url :`${BASE_URL}/Tec/UpdatetecLeaders`,
       data:body, 
       headers: {
            "Content-Type": "multipart/form-data",
            'Authorization':bearer 
        }     
    }) 

   .then((response) =>{
   console.log(response.data);


   if(response.data.status === "Success"){
   
    setUpdateToast(true)
    closeLeadersEditForm()
        setTimeout(() => {
        
         getTecLeaders()
         setUpdateToast(false)
         setcurrentPage(1)
        
        }, 2000);
      }

})
.catch(error => {
  console.log(error);
//  alert("failed !")
alert("failed to Update")   
})
  

}

}

 ///DeleteSectionA

 function DeleteSectionLeaders(Id){

 


 const body =
  {
    Id:Id,
 
   

     
  
  }
  console.log('body',body);


  axios({
         method:"POST",
         url :`${BASE_URL}/Tec/DeletetecLeaders`,
         data:body, 
         headers: {
            "Content-type": "application/json",
              'Authorization':bearer 
          }     
      }) 

     .then((response) =>{
     console.log(response.data);


     
        MaincloseForm()
         setDeleteErrToast(true)
        
        
          setTimeout(() => {
          
           getTecLeaders()
           setcurrentPage(1)
           setDeleteErrToast(false)
          }, 2000);
         
          
        

  })
  .catch(error => {
    console.log(error);
  //  alert("failed !")
  alert("failed to Update")   
  })
    
 



}

//closeAddFormLeaders

function closeLeadersAddForm(){


  setFileLeaders();
  setFileLeadersImg();

  document.getElementById("AddErrA").innerHTML=" "
  document.getElementById("AddErrB").innerHTML=" "
 
  document.getElementById("tecform").reset();
         
  document.getElementById("LeadersAddPop").style.display = "none";
 
 
}

 //closeEditForm

 function closeLeadersEditForm(){

  setFileLeaders();
  setFileLeadersImg();
  document.getElementById("ErrA").innerHTML=" "
  document.getElementById("ErrB").innerHTML=" "
  document.getElementById("teceditform").reset();

  
  document.getElementById("LeadersEditPop").style.display = "none";
 }

  //OpenAddForm

  function openLeadersForm(){

    document.getElementById("LeadersAddPop").style.display = "block";

  }
  function OpenTecGridMain(){

    getTecLeaders()
    
    document.getElementById("TecSelectMain").style.display="none"
    document.getElementById("TecGridMainA").style.display="block"
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
    setpop(true);
    
    setTimeout(()=>{
    setpop(false);
    getAssignedAction()
  
  },1000)
 

    }
  
  
    function OpenAboutContent(){

      getTecFounder()
      
      document.getElementById("TecSelectMain").style.display="none"
      document.getElementById("TecGridMainB").style.display="block"
      document.getElementById("PopBAdd").style.display="none"
      document.getElementById("PopBTable").style.display="none"
      setpop(true);
     
      setTimeout(()=>{
      setpop(false);
      getAssignedActionFound()
      
      
    },1000)
    }
  
  
    function BackMain(){
  
      document.getElementById("TecGridMainA").style.display="none"
      document.getElementById("TecGridMainB").style.display="none"
      document.getElementById("TecSelectMain").style.display="block"
  
    }


    const [sectionFounder, setSectionFounder] = useState([])
    const [EditSectionFounder, setEditSectionFounder] =useState([])
  
   ///getTecFounder
  
  
   function getTecFounder()
   {
  
   
  
   fetch(`${BASE_URL}/Tec/GettecFounder`, {
  
     method: 'GET',
  
     headers: {
  
       "Content-type": "application/json",
  
       "Accept": "application/json",
  
    
  
       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
     },
  
     //body:JSON.stringify(data)
  
   }).then(response => response.json())
  
     .then(data => {
       console.log("DatasectionA", data);
       setSectionFounder(data)
       setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
         }
     );
  
  
  
       }
       const pageCountB = sectionFounder? Math.ceil(sectionFounder.length/pageSizeB) :0;
       // if (pageCountB === 1)
       // return null;
       
       const pagesB = _.range(1, pageCountB+1)
       
       const paginationB =(pageNoB)=>{
       setcurrentPageB(pageNoB);
       const startIndex = (pageNoB - 1) * pageSizeB;
       const paginatedPostB = _(sectionFounder).slice(startIndex).take(pageSizeB).value();
       setpaginatedPostsB(paginatedPostB)
       }
       const onNextB = () => {
 
 
         paginationB(currentPageB + 1);
       };
       
       const onPreviousB = () => {
         paginationB(currentPageB - 1);
       };
         ///submitsectionFounder
  
     const [fileFounder, setFileFounder] = useState();
     const [fileFounderImg, setFileFounderImg] = useState();
     // console.log(file)
     
     const handleFileChangeFounder = (e) => {
      
         setFileFounder(e.target.files[0]);
         setFileFounderImg(URL.createObjectURL(e.target.files[0]));
     };
   
     function submitsectionFounder(){
  
      var UserId= localStorage.getItem('UserId')
  
       var textFounder = document.getElementById("Foundtext").value;
  
  
       if(!textFounder){
  
         document.getElementById("FoundAddErrA").innerHTML="Founder Name Required"
  
       }
       else if(textFounder){
  
         document.getElementById("FoundAddErrA").innerHTML=" "
  
       }
       
       if(!fileFounder){
  
         document.getElementById("FoundAddErrB").innerHTML="image Required"
  
       }
       else if(fileFounder){
  
         document.getElementById("FoundAddErrB").innerHTML=" "
  
       }
  
       if(textFounder &&fileFounder){
  
  
  
      const body =
       {
         
         Text:textFounder, 
         Image:fileFounder,
         ActiveStatus:0,
         DeleteStatus:0,
         CreatedBy:UserId
        
  
          
       
       }
       console.log('body',body);
  
     
       axios({
              method:"POST",
              url :`${BASE_URL}/Tec/AddtecFounder`,
              data:body, 
              headers: {
                   "Content-Type": "multipart/form-data",
                   'Authorization':bearer 
               }     
           }) 
   
          .then((response) =>{
          console.log(response.data);
     
     
          if(response.data.status === "Success"){
            
               //toast.success("Section Added")
               setSuccessToast(true)
            
               setTimeout(() => {
               
                getTecFounder()
                setSuccessToast(false)
                closeFounderAddForm()
               }, 2000);
             }
  
     
       })
       .catch(error => {
         console.log(error);
       //  alert("failed !")
      alert("failed to Add") 
  
       })
         
     }
  
     }
  
  
   ////Get Particular Data PostMethodFounder
  
   function  SelectParticular(Id){
  
  
   
  
  const body =
   {
     
    id:Id
   }
   console.log('body',body);
  
  
   axios({
          method:"POST",
          url :`${BASE_URL}/Tec/EdittecFounder`,
          data:body, 
          headers: {
               "Content-type": "application/json",
               'Authorization':bearer 
           }     
       }) 
       
  
       .then((response) =>{
         console.log(JSON.stringify(response.data));
    
     
         setEditSectionFounder(response.data)
  
        
    
      })
      .catch(error => {
        console.log(error);
        
      })
  
   }
  
   function editSectionFounder(Id){

    SelectParticular(Id)
  
    document.getElementById("FounderEditPop").style.display = "block";
  
  }
   function updateSectionFounder(Id){
  
  
    var UserId= localStorage.getItem('UserId')
    var TextFounder = document.getElementById("FoundtextA").value;
    var ImagefileFounder = document.getElementById("Foundtecimage").src;
  
    if(!TextFounder){
  
      document.getElementById("FoundErrA").innerHTML="Leader Name Required"
  
    }
    else if(TextFounder){
  
      document.getElementById("FoundErrA").innerHTML=" "
  
    }
    
   
   
   
    if(TextFounder){
  
  
    
  
  
  
  const body =
  {
    Id:Id,
    Text:TextFounder, 
    Image:fileFounder,
    OldImage:ImagefileFounder,
    EditedBy:UserId
  
     
  
  }
  console.log('body',body);
  
  
  axios({
         method:"POST",
         url :`${BASE_URL}/Tec/UpdatetecFounder`,
         data:body, 
         headers: {
              "Content-Type": "multipart/form-data",
              'Authorization':bearer 
          }     
      }) 
  
     .then((response) =>{
     console.log(response.data);
  
  
     if(response.data.status === "Success"){

      closeFounderEditForm()
      
          setUpdateToast(true)
          setTimeout(() => {
          
           getTecFounder()
           setUpdateToast(false)
           setcurrentPageB(1)
      
          }, 2000);
        }
  
  })
  .catch(error => {
    console.log(error);
  //  alert("failed !")
 alert("failed to Update")   
  })
    
  
  }
  
  }
  
   ///DeleteSectionA
  
   function DeleteSectionFounder(Id){
  
   
   
  
   const body =
    {
      Id:Id,
   
     
  
       
    
    }
    console.log('body',body);
  
  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/DeletetecFounder`,
           data:body, 
           headers: {
              "Content-type": "application/json",
                'Authorization':bearer 
            }     
        }) 
  
       .then((response) =>{
       console.log(response.data);
  
  
       
       setDeleteErrToast(true)
       closeForm()
          
            setTimeout(() => {
            
             getTecFounder()

             setDeleteErrToast(false)
             setcurrentPageB(1)
             
            }, 2000);
           
            
          
  
    })
    .catch(error => {
      console.log(error);
    //  alert("failed !")
    alert("failed to Delete")   
    })
      
   
  
  
  
  }
  
  //closeAddFormFounder
  
  function closeFounderAddForm(){
  
  
    setFileFounder();
   
  
    document.getElementById("FoundAddErrA").innerHTML=" "
    document.getElementById("FoundAddErrB").innerHTML=" "
   
    document.getElementById("tecFoundform").reset();
           
    document.getElementById("FounderAddPop").style.display = "none";
   
   
  }
  
   //closeEditForm
  
   function closeFounderEditForm(){
  
    setFileFounder();
    document.getElementById("FoundErrA").innerHTML=" "
    document.getElementById("FoundErrB").innerHTML=" "
    document.getElementById("tecFoundeditform").reset();
  
    
    document.getElementById("FounderEditPop").style.display = "none";
   }
  
    //OpenAddForm
  
    function openFounderForm(){
  
      document.getElementById("FounderAddPop").style.display = "block";
  
    }

 
  function getroleAction(){

   

    let LoginRole =  localStorage.getItem("Role");
 
    console.log('checkrole',LoginRole);
    const body =
    {
      
     role:LoginRole
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/GetTecRoleAction`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": bearer,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
       
                
          localStorage.setItem("LoginAction",JSON.stringify(response.data))
          localStorage.getItem("LoginAction");
       })
       .catch(error => {
         console.log(error);
  })
}

  const[editicon,setediticon] = useState(false);
  const[delicon,setdelicon] = useState(false);
  const[denied,setdenied] = useState(false);    
  function getAssignedAction(){



  ////Admin
    let LoginRole =  localStorage.getItem("RoleId");
  

    let CheckSAdmin = LoginRole.includes("00")
    let CheckAdmin =LoginRole.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


   

    if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PopAAdd').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PopAAdd').style.display ="block";
    }
    else{
      document.getElementById('PopAAdd').style.display ="none";

    }
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PopATable').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PopATable').style.display ="block";
    }
    else{
      document.getElementById('PopATable').style.display ="none";

    }
    if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
      setediticon(true)
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      setediticon(true)
    }
    else{
      setediticon(false)

    }
    if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){

      setdelicon(true)
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      setdelicon(true)
    }
    else{
      setdelicon(false)

    }

    if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

      setdenied(true)
    }
    else{

      setdenied(false)
    }

    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
      document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
       }
  }
  function getAssignedActionFound(){



    ////Admin
      let LoginRole =  localStorage.getItem("RoleId");
    
  
      let CheckSAdmin = LoginRole.includes("00")
      let CheckAdmin =LoginRole.includes("01")
  
  
     /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
      if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopBAdd').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopBAdd').style.display ="block";
      }
      else{
        document.getElementById('PopBAdd').style.display ="none";
  
      }
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopBTable').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopBTable').style.display ="block";
      }
      else{
        document.getElementById('PopBTable').style.display ="none";
  
      }
      if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setediticon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setediticon(true)
      }
      else{
        setediticon(false)
  
      }
      if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setdelicon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setdelicon(true)
      }
      else{
        setdelicon(false)
  
      }

      if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

        setdenied(true)
      }
      else{
  
        setdenied(false)
      }

      if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
        document.getElementById("TecActionDeniedA").innerHTML="View Table is not Assigned"
         }
    }

    function MainConfirmDelete(Id){

      SelectParticularMain(Id)
      setTimeout(() => {
        document.getElementById("MainmodaldeleteForm").style.display = "block";
      },1000);
    
    }
    function ConfirmDelete(Id){

      SelectParticular(Id)
      setTimeout(() => {
        document.getElementById("modaldeleteForm").style.display = "block";
      },1000);
    
    }

    function MaincloseForm(){

      document.getElementById("MainmodaldeleteForm").style.display ="None"
    
    }
    function closeForm(){

      document.getElementById("modaldeleteForm").style.display ="None"
    
    }



    
       const[SuccessToast,setSuccessToast] = useState(false);  
       const[UpdateToast,setUpdateToast] = useState(false);  
       const[DeleteToast,setDeleteErrToast] = useState(false);


  return (
    <>
  {/* Toast */}
  {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}


    <div className='tec-addmain' id="TecSelectMain">
      
    
  {/* <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>Leaders</span>

  </div>
  </div> */}

<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">LEADERS</span></span>
 <div className='tec-addmain-back'>
  <Link to="/TecIndex"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div>
  </p> 

 {/* <hr></hr> */}
 </div>    </div>   
 <div class="tec-hero"> 
  <div class="techero__title"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
</div>
 <div className='tecTwoList'>

  <div class="tecTwoList_responsive">
 <div id="TecSelectB" >

 <div id="items-body-content" onClick={OpenTecGridMain}>
 <span>Add Leaders</span>
 <i class="fa fa-angle-right"></i>
</div>
<div id="items-body-content" onClick={OpenAboutContent}>
 <span>Add Founder</span>
 <i class="fa fa-angle-right"></i>
</div>
</div>



</div>
</div>





   


    </div>

 <div id="TecGridMainA" className='tec-addmain'>
 
 <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
  
 <p><span id="tectopspan"><span id="TecTitleMain">LEADERS</span></span>
 <div className='tec-addmain-back'>
  <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 </div>

    </div>   
 <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openLeadersForm}>  Add Leaders</button>
 </div>

    
    <div className='tec-sectionMain' id="PopATable" >
    {
  sectionLeaders.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(
<div>

<div className='tectable'>

  <div class="tec-table_responsive">
<table>
  <thead>
    <tr>
      <th>Name</th>
      <th>Image</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
    <td>{e.text}</td>
  
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td style={{whiteSpace:"nowrap"}}>
      {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionLeaders(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>MainConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
 } )}
  </tbody>
</table>
</div>
</div>
  

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
   
       
       {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}


            </ul>
  </nav>}

</div>
)}
</div>
 {/* EditLeaders */}
 <div className='tec-pop-fade' id="LeadersEditPop">
{EditSectionLeaders.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"150px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT LEADERS</h4>
        <button type="button" className="close" onClick={closeLeadersEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionLeaders(e.id)}>
      <div className="modal-body mx-3">
      <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">Image</label> */}
        
         <input type="file" onChange={handleFileChangeLeaders} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}  />
         {!fileLeadersImg?<img id="tecimage" src={e.image}  /> : <img id="tecimage" src={fileLeadersImg}  />}
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
         <span id="ErrB" className='error'></span>
        </div>
        <div className="md-form mb-4">
        <label id="sectionlable">Name</label> 
          <input type="text" id="textA"  defaultValue={e.text}/>
          <span id="ErrA" className='error'></span>
        </div> 
        
      
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddLeaders */}
<div className='tec-pop-fade' id="LeadersAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"170px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD LEADERS</h4>
        <button type="button" className="close" onClick={closeLeadersAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionLeaders} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
           
        <label id="sectionlable">Name</label> 
          <input type="text" id="text"/>
          <span id="AddErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">
          <label id="sectionlable">Image</label>  
 
         <input type="file" onChange={handleFileChangeLeaders}/>
         
         <span id="AddErrB" className='error'></span>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 


  {/* DeletePopup */}

  {EditSectionLeaders.map((e)=>{ 
   return<div className="tec-pop-fade" id="MainmodaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={MaincloseForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionLeaders(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={MaincloseForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}



 

    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
    <div id="TecGridMainB" className='tec-addmain'>

     
    <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">FOUNDER</span></span>
 <div className='tec-addmain-back'>
  <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 </div>

    </div>

    <div className='tec-addmain-add' id="PopBAdd">
      <button className='add-user' onClick={openFounderForm}>  Add Founder</button>
 </div>

    
    
  


 {/* EditFounder */}
 <div className='tec-pop-fade' id="FounderEditPop">
{EditSectionFounder.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"150px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT FOUNDER</h4>
        <button type="button" className="close" onClick={closeFounderEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecFoundeditform" onSubmit={()=>updateSectionFounder(e.id)}>
      <div className="modal-body mx-3">
      <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">Image</label> */}
       
         <input type="file" onChange={handleFileChangeFounder} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}} />
         {!fileFounderImg?<img id="Foundtecimage" src={e.image}  />:<img id="Foundtecimage" src={fileFounderImg}  />}  
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
         <span id="FoundErrB" className='error'></span>
        </div>
        <div className="md-form mb-4">
        <label id="sectionlable">Name</label> 
          <input type="text" id="FoundtextA"  defaultValue={e.text}/>
          <span id="FoundErrA" className='error'></span>
        </div> 
        
   
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddFounder */}
<div className='tec-pop-fade' id="FounderAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"170px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD FOUNDER</h4>
        <button type="button" className="close" onClick={closeFounderAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecFoundform" onSubmit={submitsectionFounder} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
           
        <label id="sectionlable">Name</label> 
          <input type="text" id="Foundtext"/>
          <span id="FoundAddErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">
          <label id="sectionlable">Image</label>  
 
         <input type="file" onChange={handleFileChangeFounder}/>
         
         <span id="FoundAddErrB" className='error'></span>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 



  {/* DeletePopup */}

  {EditSectionFounder.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionFounder(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}



<div className='tec-sectionMain' id='PopBTable'>

{
  sectionFounder.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(
  <div>
<div className='tectable'>

  <div class="tec-table_responsive">
<table>
  <thead>
    <tr>
      <th>Name</th>
      <th>Image</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPostsB.map((e)=>{
    
  
    return<tr>
    <td>{e.text}</td>
  
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionFounder(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
 } )}
  </tbody>
</table>
</div>
</div>
<br></br>
{pageCountB==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
   
       
       {currentPageB >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="tecpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}

</div>

)}

    </div>
    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  id="Loader"
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
 <div id="TecDenied">
   <span id="TecActionDeniedA"></span>

   </div>
 
    </div>
    
    </>
  )
}

export default TecLeadersMain
